<template>
  <div class="ec-form-group">
    <label v-if="label" class="ec-form-label">
      {{ label }}
      <span v-if="required" class="ec-form-label__required">*</span>
    </label>
    <div
      class="ec-select"
      :class="{
        'ec-select--error': error,
        'ec-select--disabled': disabled,
      }"
    >
      <select
        class="ec-select__field"
        :value="value"
        :disabled="disabled"
        :required="required"
        @change="$emit('input', $event.target.value)"
      >
        <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
        <option v-for="opt in options" :key="opt.value" :value="opt.value">
          {{ opt.label }}
        </option>
      </select>
      <i class="ec-select__chevron bi bi-chevron-down" />
    </div>
    <div v-if="error" class="ec-form-error">{{ error }}</div>
    <small v-if="hint && !error" class="ec-form-hint">{{ hint }}</small>
  </div>
</template>

<script>
export default {
  name: 'EcSelect',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: { type: String, default: '' },
    hint: { type: String, default: '' },
  },
}
</script>
